import { types } from "api";
import { AuthStatusRole } from "./context";

export const getMaxRole = (
	roles: AuthStatusRole | types.RoleType[],
): AuthStatusRole => {
	if (Array.isArray(roles)) {
		if (roles.includes("admin")) {
			return "admin";
		} else if (roles.includes("admin-teacher")) {
			return "admin-teacher";
		} else if (roles.includes("teacher")) {
			return "teacher";
		} else if (roles.includes("parent")) {
			return "parent";
		} else if (roles.includes("student")) {
			return "student";
		}

		return "unauthenticated";
	}
	return roles;
};
